import { FA_ADVICE_AREAS, FINANCIAL_ADVISER_ID } from '../__constants__';


export function calculateShowServicesDropdownInitialState(props) {
    const { width, type } = props;

    return width !== 'xs' && type === FINANCIAL_ADVISER_ID;
}

export function calculateIfMortgageAdviserSearch(attributeIds = []) {
    return attributeIds.length === 1 && attributeIds[0] === FA_ADVICE_AREAS.MORTGAGES_ID;
}

export function getSearchFilterTypeValueByService(attributeIds = []) {
    let filterTypeValue = 'ifa'
    if (attributeIds.length === 1) {
        switch(attributeIds[0]) {
            case FA_ADVICE_AREAS.MORTGAGES_ID:
                filterTypeValue = 'mortgage_adviser'
                break;
            case FA_ADVICE_AREAS.EQUITY_RELEASE_ID:
                filterTypeValue = 'equity_release_whole_of_market'

                break;
            case FA_ADVICE_AREAS.INSURANCE_AND_PROTECTION_ID:
                filterTypeValue = 'protection_whole_of_market'
                break;
            default: 
                filterTypeValue = 'ifa'
        }
    }

    return filterTypeValue;
}
